import * as R from 'ramda'

export const omitTypeName = (object: object[]) => R.map(R.omit(['__typename']))(object)
